module.exports = __webpack_public_path__ + "static/media/fz_verifylocal_pt_PT.0980486b.png";